import AxiosInstance from '../helpers/axiosInstance';
import { ProfileInfoUpdate, ProfilePictureUpdate } from "../components/profile/basicInfoTab";
import { UpdatePassword } from "../components/profile/passwordTab";
import { ResetPasswordRequest } from "../pages/resetPassword";

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const updateProfile = async (id: number, request: ProfileInfoUpdate) => {
  try {
    console.log(`Updating profile info of user with Reg Id ${id}`);
    const response = await AxiosInstance().put(API_URL + `/user/user-registrations/${id}`, request);
    if (response.status === 204)
      console.log(`Successfully updated profile info of user with Reg Id ${id}`);
    return response;
  } catch (error) { }
};

export const updateProfilePicture = async (id: number, request: ProfilePictureUpdate) => {
  try {
    console.log(`Updating profile picture of user with Reg Id ${id}`);
    const response = await AxiosInstance().patch(
      API_URL + `/user/user-registrations/${id}/profile-pictures`,
      request);
    if (response.status === 204)
      console.log(`Successfully updated profile picture of user with Reg Id ${id}`);
    return response;
  } catch (error) { }
}

export const updatePassword = async (request: UpdatePassword) => {
  try {
    const response = await AxiosInstance().put(API_URL + `/user/change-password`, request);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

export const resetPassword = async (request: ResetPasswordRequest) => {
  try {
    const response = await AxiosInstance().put(API_URL + `/user/reset-password`, request);
    return response;
  } catch (error) {
    return { status: 400 };
  }
}

export const getResetPasswordToken = async (username: string) => {
  try {
    const response = await AxiosInstance().post(API_URL + `/user/reset-password-token`, { username: username });
    return response;
  } catch (error) {
    return { status: 400 };
  }
}